// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2222":"29c7165436edd3f7","2888":"aa90b19afd3ede9d"}[chunkId] + ".css";
};